import React from 'react';
import TermsAndConditionsView from './TermsAndConditionsView';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

function TermsAndConditions(props) {
    return <TermsAndConditionsView {...props}/>;
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isXSView: state.appState.deviceInfo.isXSView,
});

export default connect(mapStateToProps, {})(withRouter(TermsAndConditions));
